module.exports = __webpack_public_path__ + "img/lg_ring_y_0_1_0@3x.756b43ef.png";